import { logIfDebug, warnIfDebug, warnOnceIfDebug } from 'utils/log';
import { getElement } from 'utils/dom';
import { isArray } from 'utils/is';
import config from './config/config';
import Fragment from 'src/view/Fragment';
import hooks from 'src/events/Hook';
import blcktive from '../blcktive';
import subscribe from './helpers/subscribe';

export default function initialise(blcktive, userOptions, options) {
  // initialize settable computeds
  const computed = blcktive.viewmodel.computed;
  if (computed) {
    for (const k in computed) {
      if (k in blcktive.viewmodel.value && computed[k] && !computed[k].isReadonly) {
        computed[k].set(blcktive.viewmodel.value[k]);
      }
    }
  }

  // init config from Parent and options
  config.init(blcktive.constructor, blcktive, userOptions);

  // call any passed in plugins
  if (isArray(userOptions.use))
    blcktive.use.apply(blcktive, userOptions.use.filter(p => !p.construct));

  hooks.config.fire(blcktive);

  hooks.init.begin(blcktive);

  const fragment = (blcktive.fragment = createFragment(blcktive, options));
  if (fragment) fragment.bind(blcktive.viewmodel);

  hooks.init.end(blcktive);

  // general config done, set up observers
  subscribe(blcktive, userOptions, 'observe');

  if (fragment) {
    // render automatically ( if `el` is specified )
    const el = (blcktive.el = blcktive.target = getElement(blcktive.el || blcktive.target));
    if (el && !blcktive.component) {
      const promise = blcktive.render(el, blcktive.append);

      if (blcktive.DEBUG_PROMISES) {
        promise.catch(err => {
          warnOnceIfDebug(
            'Promise debugging is enabled, to help solve errors that happen asynchronously. Some browsers will log unhandled promise rejections, in which case you can safely disable promise debugging:\n  blcktive.DEBUG_PROMISES = false;'
          );
          warnIfDebug('An error happened during rendering', { blcktive });
          logIfDebug(err);

          throw err;
        });
      }
    }
  }
}

export function createFragment(blcktive, options = {}) {
  if (blcktive.template) {
    const cssIds = [].concat(blcktive.constructor._cssIds || [], options.cssIds || []);

    return new Fragment({
      owner: blcktive,
      template: blcktive.template,
      cssIds
    });
  }
}
